import { render } from "./EditPhoneModal.vue?vue&type=template&id=7c5ec0fd&scoped=true&ts=true"
import script from "./EditPhoneModal.vue?vue&type=script&lang=ts"
export * from "./EditPhoneModal.vue?vue&type=script&lang=ts"

import "./EditPhoneModal.vue?vue&type=style&index=0&id=7c5ec0fd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5ec0fd"]])

export default __exports__